export default "__VITE_ASSET__D8q5DmkO__"